import { ramses as api } from '../api'

export default async cnpj => {
  try {
    return await api.get(`/ws/cnpj/${cnpj}`)
  } catch ({ response }) {
    return response
  }
}
